import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { fontWeight } from '@mui/system';
import { textDisabled } from 'styles/theme';

export const HeaderStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    '.segmentation': {
        width: 260
    },
    '.filters-row': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.label': {
        width: 150
    }
}));

export const NumberAxisStyles = muiStyled(Box)(({ color, theme }) => ({
    padding: "0px 15px 0px 0px",
    boxSizing: "border-box",
    display: "flex",
    columnGap: 15,
    width: "100%",
    height: 30,
    alignItems: "center",
    '.wrap-layout-label': {
        width: 180,
        minWidth: 180
    },
    '.numbers': {
        direction: "rtl",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
        padding: "0px 15px"
    }
}));


export const BarLineStyles = muiStyled(Box)(({ color, theme }) => ({
    overflow: "auto",
    width: "100%",
    background: "#FFF",
    borderRadius: 16,
    flexGrow: 1,
    padding: 20,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.bar-line-container': {
        flexGrow: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.left-section': {
        width: 180
    },
    '.wrap-line-and-summary': {
        display: "flex",
        flexDirection: "column",
        rowGap: 8,
        width: "100%",
    },
    '.space1': {
        height: 25
    },
    '.affiliations-loading': {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    '.wrap-layout-label': {
        display: "flex",
        alignItems: "center",
        columnGap: 10,
    },
    '.layout-label': {
        flexGrow: 1
    },
    '.chevron-icon': {
        color: textDisabled
    },
    '.bar-item-and-label': {
        columnGap: 15,
        display: "flex",
        alignItems: "center",
    },
    '.bar-summary': {
        display: "flex",
        columnGap: 4
    },
}))
